import { render } from "./HomeFeatureArticle.vue?vue&type=template&id=fcd20de2"
import script from "./HomeFeatureArticle.vue?vue&type=script&lang=js"
export * from "./HomeFeatureArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__